<div class="row mt-3" style="padding-left: 2em; padding-right: 2em;">
    <div class="blog-posts single-post">
        <article class="post post-large blog-single-post">

            <div class="post-content">
                <div class="post-meta">
                </div>
                <p><strong><span style="color: rgb(61, 142, 185);">บทบาท</span></strong></p>
                <p style="margin-left: 20px;">&nbsp; &nbsp;สถาบันคุ้มครองเงินฝากเป็นนิติบุคคลของรัฐที่จัดตั้งขึ้นตั้งแต่ ปี
                    2551 ตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ. 2551
                    เพื่อให้ความคุ้มครองแก่ผู้ฝากเงินในสถาบันการเงินโดยเฉพาะผู้ฝากเงินรายย่อยที่เป็นคนส่วนใหญ่ของประเทศที่อาจจะไม่สามารถเข้าถึงข่าวสารทางการเงินได้อย่างเพียงพอ
                    ในกรณีที่สถาบันการเงินซึ่งอยู่ภายใต้ความคุ้มครองถูกปิดกิจการ
                    ผู้ฝากเงินจะได้รับเงินฝากคืนจากสถาบันคุ้มครองเงินฝากอย่างรวดเร็วภายใต้วงเงินและภายในระยะเวลาที่กฎหมายกำหนดไว้
                    &nbsp;ส่วนเงินฝากที่มีจำนวนเกินวงเงินจ่ายคืนดังกล่าว
                    จะได้รับคืนเพิ่มเติมจากการชำระบัญชีสถาบันการเงินที่ปิดกิจการ</p>
                <p class="mt-3"><span
                        style="color: rgb(61, 142, 185);"><strong>หน้าที่หลักของสถาบันคุ้มครองเงินฝาก</strong>&nbsp;</span>
                </p>
                <ol>
                    <li>คุ้มครองเงินฝากมรสถาบันการเงิน
                    </li>
                    <li>เสริมสร้างความมั่นคงและเสถียรภาพของระบบสถาบันการเงิน</li>
                    <li>ดําเนินการกับสถาบันการเงินที่ถูกควบคุมตามกฎหมายว่าด้วยธุรกิจสถาบันการเงิน
                        และชําระบัญชีสถาบันการเงินที่ถูกเพิกถอนใบอนุญาต</li>
                </ol>
                <p class="mt-3"><strong><span style="color: rgb(61, 142, 185);">ประโยชน์ของการมีระบบคุ้มครองเงินฝาก</span></strong>
                </p>
                <ol>
                    <li>ประโยชน์ต่อผู้ฝากเงิน : เงินฝากในสถาบันการเงินที่อยู่ภายใต้ระบบนี้ได้รับการคุ้มครองตาม พ.ร.บ.ฯ
                        โดยอัตโนมัติ ผู้ฝากไม่ต้องกังวล หรือ ดำเนินการใดๆ เพื่อให้ได้รับการคุ้มครองเงินฝาก
                        เมื่อสถาบันการเงินใดถูกเพิกถอนใบอนุญาต ผู้ฝากจะได้รับเงินคืนอย่างรวดเร็ว อีกทั้ง
                        จะส่งเสริมให้ผู้ฝากเงินติดตามข่าวสารหาข้อมูลทางการเงินมากขึ้น</li>
                    <li>ประโยชน์ต่อระบบการเงิน : สถาบันการเงินมีความเข้มแข็ง มีการแข่งเสรีตามกลไกตลาด
                        ซึ่งจะส่งผลให้ต้นทุนทางการเงินมีความเหมาะสม</li>
                    <li>ประโยชน์ต่อภาครัฐ : ภาครัฐไม่ต้องใช้เงินภาษีของประชาชนมาจ่ายคืนเงินให้แก่ผู้ฝาก</li>
                </ol>
            </div>
        </article>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.html